import imgDown from "$/image-down.svg";

interface DiaryHeaderProps {
  profileImg: string;
  petName: string;
  date: string;
  onDownload?: () => void;
  isExistPhoto?: boolean;
  /** 발송 후 수정된 경우 수정 일시 (예: "2026.07.22 14:30"). 날짜 오른쪽에 표시된다. */
  editedAt?: string | null;
  /** 썸네일 라인 오른쪽 끝에 표시할 액션 (예: 수정 버튼) */
  rightAction?: React.ReactNode;
  /** 프로필 이미지 대신 표시할 유형 아이콘 (일정공지/공지사항 — 목록 썸네일과 동일 스타일) */
  avatarIcon?: React.ReactNode;
}

export default function DiaryHeader({
  profileImg,
  petName,
  date,
  onDownload,
  isExistPhoto = false,
  editedAt = null,
  rightAction,
  avatarIcon,
}: DiaryHeaderProps) {
  return (
    <div className="flex gap-2 items-center py-2 mb-2">
      {avatarIcon ? (
        <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border border-[#F0F0F0] bg-[#FFF3E5] [&_svg]:h-5 [&_svg]:w-5">
          {avatarIcon}
        </span>
      ) : (
        <img
          src={profileImg}
          alt="프로필"
          className="object-cover flex-shrink-0 w-10 h-10 rounded-full"
        />
      )}
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-m">{petName} 알림장</div>
        <div className="flex justify-between items-center w-full">
          <div className="flex flex-wrap gap-x-2 items-center">
            <span className="text-gray-400 text-s">{date}</span>
            {editedAt && (
              <span className="text-[11px] text-gray-400 whitespace-nowrap">
                수정됨 {editedAt}
              </span>
            )}
          </div>
          {isExistPhoto && (
            <button
              className="flex flex-shrink-0 gap-1 items-center text-gray-400 text-s"
              onClick={onDownload}
            >
              <img src={imgDown} alt="다운로드" />
              전체 다운로드
            </button>
          )}
        </div>
      </div>
      {rightAction && <div className="flex-shrink-0">{rightAction}</div>}
    </div>
  );
}
